import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NotificationOnExitGuard } from './guards';
import { HammerConfig, PreloadSelectedModules } from './classes';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { ErrorService } from "./services/error.service";
import { ToastService } from "./services/toast.service";
import { ConfirmationService } from "./services/confirmation.service";
import { ComponentGeneratorService } from "./services/component-generator.service";
import { NetworkService } from "./services/network.service";
import { UpdatesService } from "./services/updates.service";
import { LegacyDriverNameInterceptor } from './interceptors/legacy-driver-name.interceptor';
import { TimestampInterceptor } from './interceptors/timestamp.interceptor';
import { ZenithToastService } from '../components/zenith/zenith-toast/zenith-toast.service';

@NgModule({
    imports: [
        CommonModule,
        ZenithComponentsModule,
    ],
    providers: [
        PreloadSelectedModules,
        ErrorService,
        ToastService,
        ZenithToastService,
        ConfirmationService,
        ComponentGeneratorService,
        NotificationOnExitGuard,
        PreloadSelectedModules,
        NetworkService,
        UpdatesService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LegacyDriverNameInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TimestampInterceptor,
            multi: true
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerConfig
        },
    ]
})
export class CoreModule {
    /* make sure CoreModule is imported only by one NgModule the AppModule */
    constructor(
        @Optional() @SkipSelf() parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import only in AppModule');
        }
    }
}
